import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiUsers, FiMessageSquare, FiUserCheck, FiTrendingUp, FiSettings, FiBarChart3 } = FiIcons;

const menuItems = [
  { path: '/dashboard', name: 'Dashboard', icon: FiHome },
  { path: '/sales', name: 'Umsätze', icon: FiTrendingUp },
  { path: '/customers', name: 'Kunden', icon: FiUserCheck },
  { path: '/contacts', name: 'Kontakte', icon: FiUsers },
  { path: '/templates', name: 'Vorlagen', icon: FiMessageSquare },
  { path: '/settings', name: 'Einstellungen', icon: FiSettings },
];

function Sidebar({ isOpen, setIsOpen }) {
  const location = useLocation();

  return (
    <>
      <motion.div 
        className={`fixed left-0 top-0 h-full bg-white shadow-lg z-30 transition-all duration-300 ${isOpen ? 'w-64' : 'w-16'}`}
        initial={false}
        animate={{ width: isOpen ? 256 : 64 }}
      >
        <div className="p-4 border-b border-gray-200">
          <div className="flex flex-col items-center gap-3">
            {/* GRT Logo */}
            {isOpen ? (
              <motion.div 
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                exit={{ opacity: 0, scale: 0.8 }}
                className="w-full flex justify-center"
              >
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/188d28ca79396b10316442dd52ddfdac34c3bc88f5271b3659057f1fc32a59f71a5c67b62c6ac79453badaa74a37a081/images/aW1hZ2UvcG5n/90077c72643406ce97675763135e31fb.png" 
                  alt="GrundrissTausch Logo" 
                  className="h-12 w-auto object-contain"
                />
              </motion.div>
            ) : (
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FiBarChart3} className="text-white text-lg" />
              </div>
            )}
            
            {/* App Title */}
            {isOpen && (
              <motion.div 
                initial={{ opacity: 0 }} 
                animate={{ opacity: 1 }} 
                exit={{ opacity: 0 }}
                className="font-bold text-gray-900 text-center text-sm"
              >
                GrundrissTausch CRM
              </motion.div>
            )}
          </div>
        </div>

        <nav className="mt-8">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 mx-2 rounded-lg transition-colors ${
                  isActive 
                    ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-600' 
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                <SafeIcon icon={item.icon} className="text-lg flex-shrink-0" />
                {isOpen && (
                  <motion.span 
                    initial={{ opacity: 0 }} 
                    animate={{ opacity: 1 }} 
                    exit={{ opacity: 0 }}
                    className="font-medium"
                  >
                    {item.name}
                  </motion.span>
                )}
              </Link>
            );
          })}
        </nav>
      </motion.div>

      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden" 
          onClick={() => setIsOpen(false)} 
        />
      )}
    </>
  );
}

export default Sidebar;